 import {emptyValidator, formValidator} from "../../validators";

const exchangeHeaderValidationStatus ={
    exhFrom: {
        validators: [emptyValidator()],
        name: "From",
    },exhTo: {
        validators: [emptyValidator()],
        name: "To",
    },exhBaseCurrency: {
        validators: [emptyValidator()],
        name: "Base Currency",
    },
}
export const exchangeHeaderValidations = (exhValidations) => {
    return formValidator(exhValidations, exchangeHeaderValidationStatus);
}
const exchangeRateValidationStatus = {
    excCurrency: {
        validators: [emptyValidator()],
        name: "Currency",
    },
    excRate: {
        validators: [emptyValidator()],
        name: "Rate",
    },
}

export const exchangeRateValidations = (excValidations) => {
    return formValidator(excValidations, exchangeRateValidationStatus)
}
